'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _toggleContent = require('./toggle-content');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  slides: '[data-el="image-text-carousel.slides"]'
};

var ImageTextCarousel = function () {
  /** @param {HTMLElement} el */
  function ImageTextCarousel(el) {
    (0, _classCallCheck3.default)(this, ImageTextCarousel);

    this.el = el;

    this.els = {
      slides: this.el.querySelector(selectors.slides)
    };

    this.carousel = new _flickity2.default(this.els.slides, {
      arrowShape: {
        x0: 10,
        x1: 40,
        y1: 30,
        x2: 40,
        y2: 25,
        x3: 15
      },
      pageDots: false,
      watchCSS: true,
      wrapAround: true
    });

    this.setupListeners();
  }

  (0, _createClass3.default)(ImageTextCarousel, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.el.addEventListener(_toggleContent.events.update, function () {
        _this.carousel.resize();
      });
    }
  }]);
  return ImageTextCarousel;
}();

exports.default = ImageTextCarousel;